<div
    id="app-toolbar"
    (wheel)="servicesMenu.hide(); supportMenu.hide(); profileMenu.hide()"
    [class.sidebar-expanded]="!isSidebarCollapsed()">
    <span style="margin-right: 7px; margin-top: 2px" class="container">
        <new-order-button></new-order-button>
    </span>
    <div #navBtnServicesContainer class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-services"
            #navBtnServices
            tabindex="0"
            [attr.aria-expanded]="menuServicesOpened()"
            (click)="servicesMenu.toggle($event)">
            <span class="screen-lg" pButtonLabel>
                {{ 'toolbar.services' | translate }} <i class="fa-regular fa-angle-down"></i>
            </span>
            <span class="screen-sm" pButtonLabel>YX</span>
        </button>
    </div>

    <div #navBtnSupportContainer class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-support"
            #navBtnSupport
            tabindex="0"
            [attr.aria-expanded]="menuSupportOpened()"
            (click)="supportMenu.toggle($event)">
            <span class="screen-lg" pButtonLabel>
                {{ 'toolbar.support' | translate }} <i class="fa-regular fa-angle-down" aria-hidden="true"></i>
            </span>
            <span class="screen-sm" pButtonLabel><i class="fa-light fa-circle-question"></i></span>
        </button>
    </div>

    <div class="container" id="notifications-container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-notifications"
            tabindex="0"
            aria-label="Notifications"
            [routerLink]="urls.ACCOUNT_MESSAGES">
            <i class="fa-light fa-bell" pButtonIcon></i>
        </button>
    </div>

    <div class="container">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-cart"
            tabindex="0"
            aria-label="Cart"
            [routerLink]="urls.ORDERS_LISTING">
            <i class="fa-light fa-cart-shopping" pButtonIcon></i>
        </button>
    </div>

    <div
        #navBtnSupportContainer
        class="container"
        [style.display]="currentUser()?.id && !hideUserInfo() ? 'initial' : 'none'">
        <button
            pButton
            type="button"
            class="p-button-secondary p-button-text nav-btn"
            id="nav-btn-user"
            #navBtnUser
            tabindex="0"
            [attr.aria-expanded]="menuProfileOpened()"
            (click)="profileMenu.toggle($event)">
            <span style="min-height: 31px; display: flex; justify-content: center; flex-direction: column">
                <p id="nav-current-user-name">
                    {{ userShortName() ?? '-' }}
                </p>
                @if (currentUser()?.isAdmin) {
                    <p id="nav-current-user-role" style="margin-top: 5px">ADMIN</p>
                }
            </span>
            <span id="user-avatar-container">
                <user-avatar></user-avatar>
            </span>
        </button>
    </div>

    @if (isOnImpersonation()) {
        <button
            pButton
            type="button"
            class="p-button-danger p-button-text nav-btn"
            id="nav-btn-stop-impersonation"
            tabindex="0"
            severity="danger"
            aria-label="Stop Impersonation"
            (click)="stopImpersonation()">
            <i class="fa-light fa-ban" pButtonIcon></i>
        </button>
    }
</div>

<p-popover
    #servicesMenu
    styleClass="action-item-menu"
    [focusOnShow]="true"
    [appendTo]="navBtnServicesContainer"
    (onShow)="menuServicesOpened.set(true)"
    (onHide)="menuServicesOpened.set(false)">
    <app-menu-services
        #servicesMenu
        (mouseleave)="servicesMenu.hide()"
        (wheel)="servicesMenu.hide()"
        (closePopover)="servicesMenu.hide(); navBtnServices.focus()"></app-menu-services>
</p-popover>

<p-popover
    #supportMenu
    [styleClass]="currentUser()?.id && !hideUserInfo() ? 'action-item-menu' : 'action-item-menu support-unauth-indent'"
    [focusOnShow]="true"
    [appendTo]="navBtnSupportContainer"
    (onShow)="menuSupportOpened.set(true)"
    (onHide)="menuSupportOpened.set(false)">
    <app-menu-support
        (mouseleave)="supportMenu.hide()"
        (wheel)="supportMenu.hide()"
        (closePopover)="supportMenu.hide(); navBtnSupport.focus()"></app-menu-support>
</p-popover>

<p-popover
    #profileMenu
    styleClass="action-item-menu"
    [focusOnShow]="true"
    [appendTo]="navBtnSupportContainer"
    (onShow)="menuProfileOpened.set(true)"
    (onHide)="menuProfileOpened.set(false)">
    <app-menu-profile
        (mouseleave)="profileMenu.hide()"
        (wheel)="profileMenu.hide()"
        (closePopover)="profileMenu.hide(); navBtnUser.focus()"></app-menu-profile>
</p-popover>
